var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpeakersFormIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 21,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#speakers-form-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M16 9V6l-6-6H2c-.3 0-.5 0-.8.1C1 .2.7.4.6.5.4.7.3.9.2 1.2c-.2.3-.2.6-.2.8v16.2c0 .3 0 .5.1.8.1.2.3.5.4.7.2.2.4.3.6.4s.5.2.8.1l6.1.2q-.3-1.2-.3-2.4c0-2.3.8-4.5 2.3-6.1 1.5-1.7 3.6-2.7 5.8-2.9zM9 2l5 5.1H9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M17.3 17.5c-.2 0-.4 0-.6.1-.2 0-.3.2-.5.3l-3.6-2.1V15l3.6-2.1c.1.1.3.2.5.3q.45.15.9 0c.3-.1.6-.3.8-.5q.3-.45.3-.9c0-.3 0-.7-.3-.9-.2-.3-.4-.5-.8-.6-.3-.1-.6-.1-1 0-.3 0-.6.3-.8.6q-.3.45-.3.9v.4l-3.6 2.1c-.1 0-.2-.2-.4-.2h-.1c-.4-.2-.8-.2-1.1 0-.4.1-.7.4-.8.8-.2.4-.2.8 0 1.1s.4.7.7.9c.2.1.5.2.7.2s.4 0 .6-.1c.2 0 .3-.2.5-.3l3.6 2.1v.4c0 .3 0 .6.3.9s.4.5.7.6q.45.15.9 0c.3 0 .6-.2.8-.4s.4-.5.4-.8v-.9c-.1-.3-.3-.5-.6-.7-.2-.2-.5-.3-.8-.3z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "speakers-form-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h19v21H0z"
})))));
export { SvgSpeakersFormIcon as ReactComponent };
export default __webpack_public_path__ + "3f3529e83a52a1061bcfa3d1db469e18.svg";